import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  CmsConfig, ConfigModule,

  I18nModule,
  NotAuthGuard,

  provideConfig
} from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { CustomIconsModule } from "../../../../../custom/icons/custom-icons.module";
import { CustomResetPasswordComponent } from './custom-reset-password.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ResetPasswordComponent: {
          component: CustomResetPasswordComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        ResetPasswordComponent: {
          component: CustomResetPasswordComponent,
          guards: [NotAuthGuard]
        },
      },
    } as CmsConfig),
  ],
  declarations: [CustomResetPasswordComponent],
})
export class CustomResetPasswordModule { }
